module.exports = __webpack_public_path__ + "static/media/ic-reservation.ab535642.svg";